
import React, { Component } from "react"
import { connect } from 'react-redux'
import { Input, DropDownList,InputDecimal } from "../core"
import {
    getAssetClassAction,
    getAssetClassFirstAction,
    getCostCenterAction,
    getPlantInfoAction,
    getPMLocationAction,
    getUOMAction,
    clearSearchDirectoryInfoAction
} from '../../redux/actions/MasterAction'
import {
    setKeyValueAction,
    clearModalAction
} from '../../redux/actions/ModalEmployeeAction'
import {
    setModalCostCenterKeyAction
}
from '../../redux/actions/ModalCostCenterAction'
import utilityHelper from '../../helpers/helperUtil'
import { data_t_NEW_ASSET } from '../../configs/datas'
import { msg } from '../../components/Notifications/MsgBox'
import {EVENT_COST_CENTER_SELECTED} from '../../configs/EventTypes'

class NewAsset extends Component {
    constructor() {
        super()
        
        this.state = {
            newAssetModalKey  : "NEW_ASSET",
            asset: {
                ...data_t_NEW_ASSET[0]
            },
            assetClasses: [],
            assetClass_Name: null,
            assetClass_Type: null,
            plants: [],
            locations: [],
            unit_uoms: []
        }

        this.initState = this.initState.bind(this)
        this.validateSave=this.validateSave.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleGoBack = this.handleGoBack.bind(this)
        this.handleSaveAsset = this.handleSaveAsset.bind(this)
        this.formatDisplayEmployee = this.formatDisplayEmployee.bind(this)
        this.searchEmployeeModal = this.searchEmployeeModal.bind(this)
        this.openCostCenterModal=this.openCostCenterModal.bind(this)
       
        window.onSearchEmployeeSelected = this.handleSearchEmployeeSelected.bind(this)
        window.emitter.addListener(EVENT_COST_CENTER_SELECTED,this.handleCostCenterSelected.bind(this) )
    }

    initState() {
        this.setState({
            asset: data_t_NEW_ASSET,
            assetClass: [],
            assetClass_Name: null,
            assetClass_Type: null
        })
    }

    // handleChange(event) {
    //     this.props.handleChange(event)
    // }

    async handleChange(event, committed) {
        const target = event.target
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name

        if (valid) {

            this.setState({
                asset: {
                    ...this.state.asset,
                    [name]: value
                }
            })
        }

        if (name === "asset_class") {
            let assetClass = await this.props.getAssetClassFirst(value)

            if (assetClass) {
                this.setState({
                    asset: {
                        ...this.state.asset,
                        asset_class_name: assetClass.key1
                    },
                    assetClass_Name: assetClass.key1,
                    assetClass_Type: assetClass.key2
                })
            }
        }

        if (name === "asset_plant") {
            this.props.getPMLocation(value).then(response => {
                let result = utilityHelper.toSelectList_CombineFields(response.data, "code", "name", "code")

                this.setState({ 
                    asset_location: null,
                    locations: result
                 })
            })
        }
    }

    formatDisplayEmployee(empCode, empName) {
        if (empCode && empName)
            return `${empName} (${empCode})`
        else
            return ''
    }

    handleSearchEmployeeSelected(key, empCode, empName, empData) {
        if (!empCode || !empName) return

        if (key == "NEW_ASSET") {
            this.setState({
                asset: {
                    ...this.state.asset,
                    personal_number: empCode,
                    personal_name: empName
                }
            })
        }
    }

    searchEmployeeModal() {
        this.props.clearSearchDirectoryInfo();
        this.props.clearModal();

        this.props.setKeyValue('NEW_ASSET', null, null)

        window.$('#searchEmployeeModal').modal('show');
    }

    handleGoBack() {
        this.props.onGoBack()
    }

    validateSave(){
        let result=true
        let errors=[]
        const { asset}=this.state
        let {assetModalOptions } = this.props

        if(!asset.asset_class || asset.asset_class.length==0){
            errors.push("กรุณาระบุ Asset Class")
            result=false
        }

        if(assetModalOptions.poType !="service"){
            let start=1
            let qty=1

        if(!asset.start_sequence || asset.start_sequence.length==0 || parseInt(asset.start_sequence)==0){
            // errors.push("กรุณาระบุ Sequence Start")
            // result=false
        }
        else{
            start=parseInt(asset.start_sequence)
        }
        
        if(!asset.no_of_similar_asset || asset.no_of_similar_asset.length==0 || parseInt(asset.no_of_similar_asset)==0){
            errors.push("กรุณาระบุ No. Of Similar Asset")
            result=false
        }
        else{
            qty=parseInt(asset.no_of_similar_asset)
        }

            if(((start-1) + qty)>99){
                errors.push("ไม่สามารถสร้าง New Asset เกินจำนวนรายการที่กำหนดได้")
                result=false
            }

        }

        if(!asset.asset_description_1 || asset.asset_description_1.length==0){
            errors.push("กรุณาระบุ Description 1")
            result=false
        }

        if(!asset.asset_cost_center || asset.asset_cost_center.length==0){
            errors.push("กรุณาระบุ Cost Center")
            result=false
        }

        if(!asset.asset_plant || asset.asset_plant.length==0){
            errors.push("กรุณาระบุ Plant")
            result=false
        }

        if(!asset.asset_location || asset.asset_location.length==0){
            errors.push("กรุณาระบุ Location")
            result=false
        }

        if (errors.length > 0) {
            msg.error(errors.join('<br/>'))
         }
            
        return result
    }

    handleSaveAsset() {
        const { asset } = this.state
        
        if(this.validateSave()){
            this.initState()
            this.props.onSaveAsset(asset)
        } 
    }

    openCostCenterModal() {
        let {newAssetModalKey}=this.state
       this.props.setModalCostCenterKey(newAssetModalKey)

        window.$('#searchCostCenterModal').modal('show');
    }

    handleCostCenterSelected(refKey,value){
        let {newAssetModalKey}=this.state
      
        if(newAssetModalKey !=refKey)return

        if (value) {
            //console.log("handleSelectIO")

            this.setState({
                asset:
                    {...this.state.asset,
                    asset_cost_center:value}
            })
        } 
    }

    componentDidMount() {
        // this.props.getAssetClass().then(response => {
        //     let result = utilityHelper.toSelectList(response.data, "display", "value")
        //     this.setState({ assetClasses: result })
        // })

        // this.props.getCostCenter().then((response) => {
        //     let result = utilityHelper.toSelectList(response.data, "description", "cosT_CENTER")
        //     this.setState({ cost_centers: result })
        // })

        // this.props.getPlantInfo(null).then(response => {
        //     let result = utilityHelper.toSelectList_CombineFields(response.data, "planT_CODE", "planT_DESC", "planT_CODE")
        //     this.setState({ plants: result })
        // })

        // this.props.getUOM().then(response => {
        //     let result = utilityHelper.toSelectList_CombineFields(response.data,"commercial", "uniT_TEXT", "commercial")
        //     this.setState({ unit_uoms: result })
        // })
    }

    render() {
        let {
            asset,
            assetClass_Type,
            locations,
        } = this.state
        let { isOpen, assetModalOptions, assetClasses, plants, unit_uoms } = this.props

        return (
            isOpen === true ? <React.Fragment>
                <div id="div_createAssetClassType">
                    <div className="rrs-detail header-item-acc">
                        <div className="row">
                            <div className="col-md-4">
                                <h5 className="text-header-item-acc">Asset Class Type</h5>
                            </div>
                        </div>
                    </div>

                    <div className="rrs-container rrs-detail3">
                        <div className="row">
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.class"
                                    className="rrs-detail-label" htmlFor="sp-input1"><span className="required">*</span>Asset Class</label>
                                </div>
                            </div>
                            <div className="col-md-2 p-2">
                                <div className="form-group">
                                    <DropDownList
                                        name="asset_class"
                                        tagid="asset.class"
                                        doctype={assetClass_Type}
                                        options={assetClasses || []}
                                        onSelectChanged={this.handleChange}
                                        selected={asset.asset_class}
                                    >
                                    </DropDownList>
                                </div>
                            </div>
                            <div className="col-md-2 p-2 ml-4">
                                <div className="form-group">
                                    <label className="rrs-detail-label" htmlFor="sp-input1">Asset Class Name</label>
                                </div>
                            </div>
                            <div className="col-md-4 p-2">
                                <div className="form-group">
                                    <Input
                                        type="text"
                                        name="asset_class_name"
                                        doctype={assetClass_Type}
                                        tagid="asset.asset_class_name"
                                        value={asset.asset_class_name || ''}
                                        readOnly={true}
                                        disabled="disabled"
                                        maxlength="50"
                                    />
                                </div>
                            </div>
                        </div>
                        
                       { assetModalOptions.poType !=="service" && (<div className="row" >
            <div className="col-md-2 p-2 ml-3">
                <div className="form-group">
                    <label 
                    id="lbl-asset.number_of_asset"
                    className="rrs-detail-label" htmlFor="sp-input1"><span className="required">*</span>No. Of Similar Asset</label>
                </div>
            </div>
            <div className="col-md-2 p-2">
             <div className="form-group">
                <InputDecimal
                    doctype={assetClass_Type}
                    tagid="asset.number_of_asset"
                    className="form-control form-control-small"
                    name="no_of_similar_asset"
                    onBlur={this.handleChange}
                    defaultValue={1}
                    inputMode="decimal"
                    step="0,0"
                    floatingPoint={0}
                />
             </div>
            </div>
            <div className="col-md-2 p-2 ml-4" >
                <div className="form-group">
                    <label className="rrs-detail-label" htmlFor="sp-input1">Sequence Start</label>
                </div>
            </div>
            <div className="col-md-4 p-2">
                <div className="form-group">
                <InputDecimal
                    className="form-control form-control-small"
                    name="start_sequence"
                    onBlur={this.handleChange}
                    defaultValue={1}
                    inputMode="decimal"
                    step="0,0"
                    floatingPoint={0}
                />
                </div>
            </div>
        </div>)}
                    </div>
                    <div className="rrs-detail header-item-acc">
                        <div className="row">
                            <div className="col-md-4">
                                <h5 className="text-header-item-acc">General</h5>
                            </div>
                        </div>
                    </div>
                    <div className="rrs-detail">
                        <div className="row">
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.description_1"
                                    className="rrs-detail-label" htmlFor="sp-input1"><span className="required">*</span>Description 1</label>
                                </div>
                            </div>
                            <div className="col-md-8 p-2">
                                <div className="form-group">
                                    <Input
                                        type="text"
                                        name="asset_description_1"
                                        doctype={assetClass_Type}
                                        tagid="asset.description_1"
                                        onChange={this.handleChange}
                                        maxlength="50"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.description_2"
                                    className="rrs-detail-label" htmlFor="sp-input1">Description 2</label>
                                </div>
                            </div>
                            <div className="col-md-8 p-2">
                                <div className="form-group">
                                    <Input
                                        type="text"
                                        name="asset_description_2"
                                        tagid="asset.description_2"
                                        doctype={assetClass_Type}
                                        onChange={this.handleChange}
                                        maxlength="50"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.main"
                                    className="rrs-detail-label" htmlFor="sp-input1">Asset Main number text</label>
                                </div>
                            </div>
                            <div className="col-md-8 p-2">
                                <div className="form-group">
                                    <Input
                                        type="text"
                                        name="main_num_text"
                                        tagid="asset.main"
                                        doctype={assetClass_Type}
                                        onChange={this.handleChange}
                                        maxlength="50"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.serial_no"
                                    className="rrs-detail-label" htmlFor="sp-input1">Serial Number</label>
                                </div>
                            </div>
                            <div className="col-md-3 p-2">
                                <div className="form-group">
                                    <Input
                                        type="text"
                                        name="asset_serial_number"
                                        tagid="asset.serial_number"
                                        doctype={assetClass_Type}
                                        onChange={this.handleChange}
                                        maxlength="18"
                                    />
                                </div>
                            </div>
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.inventory_no"
                                    className="rrs-detail-label" htmlFor="sp-input1">Inventory Number</label>
                                </div>
                            </div>
                            <div className="col-md-3 p-2">
                                <div className="form-group">
                                    <Input
                                        type="text"
                                        name="asset_inventory_number"
                                        tagid="asset.inventory_no"
                                        doctype={assetClass_Type}
                                        onChange={this.handleChange}
                                        maxlength="25"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.quantity"
                                    className="rrs-detail-label" htmlFor="sp-input1">Quantity</label>
                                </div>
                            </div>
                            <div className="col-md-3 p-2">
                                <div className="form-group">
                                    <InputDecimal
                                    doctype={assetClass_Type}
                                    tagid="asset.quantity"
                                    className="form-control form-control-small"
                                    name="asset_quantity"
                                    onBlur={this.handleChange}
                                    defaultValue={1}
                                    inputMode="decimal"
                                    step="0,0"
                                    floatingPoint={0}
                                />
                                </div>
                            </div>
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.unit"
                                    className="rrs-detail-label" htmlFor="sp-input1">Unit</label>
                                </div>
                            </div>
                            <div className="col-md-3 p-2">
                                <div className="form-group">
                                    <DropDownList
                                        name="asset_unit"
                                        tagid="asset.unit"
                                        doctype={assetClass_Type}
                                        options={unit_uoms || []}
                                        onSelectChanged={this.handleChange}
                                        selected={asset.asset_unit}
                                    >
                                    </DropDownList>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="rrs-detail header-item-acc">
                        <div className="row">
                            <div className="col-md-4">
                                <h5 className="text-header-item-acc">Time Dependent</h5>
                            </div>
                        </div>
                    </div>
                    <div className="rrs-detail">
                        <div className="row">
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.cost_center"
                                    className="rrs-detail-label" htmlFor="sp-input1"><span className="required">*</span>Cost Center</label>
                                </div>
                            </div>
                            <div className="col-md-3 p-2">
                                <Input
                                    type="text"
                                    name="asset_cost_center"
                                    value={asset.asset_cost_center || ''}
                                    className="form-control control-icon-search w-100"
                                    id="cost_center"
                                    onChange={(event) => this.handleChange(event)}
                                    doctype={assetClass_Type}
                                    tagid="asset.cost_center"
                                    onClick={(event) => this.openCostCenterModal(event)}
                                    readOnly={true}
                                />

                                     {/* <DropDownList
                                        name="asset_cost_center"
                                        tagid="asset.cost_center"
                                        doctype={assetClass_Type}
                                        options={cost_centers || []}
                                        onSelectChanged={this.handleChange}
                                        selected={asset.asset_cost_center}
                                    >
                                    </DropDownList> */}
                                </div>
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.plant"
                                    className="rrs-detail-label" htmlFor="sp-input1"><span className="required">*</span>Plant</label>
                                </div>
                            </div>
                            <div className="col-md-3 p-2">
                                <div className="form-group">
                                    <DropDownList
                                        name="asset_plant"
                                        tagid="asset.plant"
                                        doctype={assetClass_Type}
                                        options={plants || []}
                                        onSelectChanged={this.handleChange}
                                        selected={asset.asset_plant}
                                    >
                                    </DropDownList>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.vehicle_no"
                                    className="rrs-detail-label" htmlFor="sp-input1">License Plate of Vehicle</label>
                                </div>
                            </div>
                            <div className="col-md-3 p-2">
                                <div className="form-group">
                                    <Input
                                        type="text"
                                        name="license_plat_of_vehicle"
                                        tagid="asset.vehicle_no"
                                        doctype={assetClass_Type}
                                        onChange={this.handleChange}
                                        maxlength="15"
                                    />
                                </div>
                            </div>
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.location"
                                    className="rrs-detail-label" htmlFor="sp-input1"><span className="required">*</span>Location</label>
                                </div>
                            </div>
                            <div className="col-md-3 p-2">
                                <div className="form-group">
                                    <DropDownList
                                        name="asset_location"
                                        tagid="asset.location"
                                        doctype={assetClass_Type}
                                        options={locations || []}
                                        onSelectChanged={this.handleChange}
                                        selected={asset.asset_location}
                                    >
                                    </DropDownList>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.personnel_no"
                                    className="rrs-detail-label" htmlFor="sp-input1">Personal Number</label>
                                </div>
                            </div>
                            <div className="col-md-3 p-2">
                                         <Input
                                                value={this.formatDisplayEmployee(asset.personal_number, asset.personal_name)}
                                                className="form-control control-icon-search"
                                                name="personal_number"
                                                onClick={() => this.searchEmployeeModal()}
                                                doctype={assetClass_Type}
                                                tagid="asset.personnel_no"
                                                readOnly={true}
                                            />
                            </div>
                            <div className="col-md-2 p-2 ml-3">
                                <div className="form-group">
                                    <label 
                                    id="lbl-asset.room"
                                    className="rrs-detail-label" htmlFor="sp-input1">Room</label>
                                </div>
                            </div>
                            <div className="col-md-3 p-2">
                                <div className="form-group">
                                    <Input
                                        type="text"
                                        name="asset_room"
                                        tagid="asset.room"
                                        doctype={assetClass_Type}
                                        onChange={this.handleChange}
                                        maxlength="8"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rrs-detail py-1">
                    <div className="row sp-table-content-footer">
                        <div className="col-12 sp-header-button-panel2">
                            <a href="#main" onClick={() => this.handleGoBack()} className="sp-btn-icon btn-del">
                                <i className="icon btn-order-delete" />
                                <span className="sp-btn-icon-label">Back</span>
                            </a>
                            <a href="#main" className="sp-btn-icon" onClick={() => this.handleSaveAsset()}>
                                <i className="icon btn-order-savedraft" />
                                <span className="sp-btn-icon-label">Save</span>
                            </a>
                        </div>
                    </div>
                </div>
                
            </React.Fragment> : null
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, AssetRedux } = state
    return {
        assetModalOptions: AssetRedux.assetModalOptions,
        viewMode: MainRedux.viewMode
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAssetClass: () => dispatch(getAssetClassAction()),
        getCostCenter: () => dispatch(getCostCenterAction()),
        getPlantInfo: (purOrg) => dispatch(getPlantInfoAction(purOrg)),
        getAssetClassFirst: (id) => getAssetClassFirstAction(id),
        getPMLocation: (plant) => getPMLocationAction(plant),
        getUOM: () => dispatch(getUOMAction()),
        clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
        setKeyValue: (table, empCode, empName) => dispatch(setKeyValueAction(table, empCode, empName)),
        clearModal: () => dispatch(clearModalAction()),
        setModalCostCenterKey: (refKey) => dispatch(setModalCostCenterKeyAction(refKey))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewAsset)